module.exports = __webpack_public_path__ + "img/title-1.298bd3e5.png";